import {Box, Text} from '@chakra-ui/react';

interface SectionTitleProps {
  title?: string;
  background?: string;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  background,
}) => (
  <Box
    textAlign="center"
    pt={{base: '84px', md: '100px', lg: '120px'}}
    pb={{base: '35px', md: '48px', lg: '48px'}}
    bg={background}
  >
    <Text textStyle="h4_1c" fontSize={{base: '28px', md: '40px'}}>
      {title}
    </Text>
  </Box>
);
